
  
    <div class="mask" *ngIf="loading" style="z-index: 9999!important;">
      <div class="loading" style="z-index: 9999!important;">
        <span>Carregando...</span>
      </div>
    </div>
    
    <router-outlet></router-outlet>     
    
  